import { ref } from "vue"

export function useVoucherData() {
  const vouchers = ref([])
  const loading = ref(false)
  const error = ref(null)

  async function load() {
    loading.value = true
    error.value = null

    try {
      const url = "/api/vouchers/hvip"

      const controller = new AbortController()
      const timeoutMs = 30_000
      const timeout = setTimeout(() => controller.abort(), timeoutMs)
      const res = await fetch(url, { signal: controller.signal })
      clearTimeout(timeout)

      if (!res.ok) throw new Error(`HTTP ${res.status}`)

      vouchers.value = await res.json()
      // console.log(`Loaded ${vouchers.value.length} hvip vouchers`)
      // show first 5 vouchers in console for debugging
      // console.log("First 5 vouchers:", vouchers.value.slice(0, 5))
    } catch (e) {
      if (e.name === "AbortError") {
        error.value = "Request timed out"
      } else {
        error.value = e?.message || String(e)
      }
      vouchers.value = []
      // console.error("Voucher load failed:", e)
    } finally {
      loading.value = false
    }
  }

  return { vouchers, loading, error, load }
}